import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const SettingsPage = lazy(() =>
  import("@/admin/pages/SettingsPage").then((m) => ({ default: m.SettingsPage })),
);

export const Route = createFileRoute("/admin/settings")({
  component: () => (
    <Suspense fallback={null}>
      <SettingsPage />
    </Suspense>
  ),
});
